import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';

import { IBetslip } from '../../../../bet-generation/models';
import { SingleSlipType } from '../../../../bet-generation/slip-type';
import { NoMultiSinglesPreCheckError } from '../../../errors/pre-check/no-multi-singles-pre-check-error';
import { IPureBetslipValidator } from './validators';

@Injectable()
export class NoMultiSinglesValidator implements IPureBetslipValidator<NoMultiSinglesPreCheckError> {
    constructor(private betslipConfig: BetslipConfig) {}

    validate(betslip: IBetslip): NoMultiSinglesPreCheckError[] {
        if (this.betslipConfig.allowMultipleSingles || betslip.slips.filter((s) => s.type instanceof SingleSlipType).length <= 1) {
            return [];
        }

        return [new NoMultiSinglesPreCheckError()];
    }
}
